import {BudgetConcept} from "./BudgetConcept";

export const BudgetConceptNames: Record<BudgetConcept, string> = {
  [BudgetConcept.FOOD]: "Comida",
  [BudgetConcept.ACCOMMODATION]: "Hospedaje",
  [BudgetConcept.FUEL]: "Combustible",
  [BudgetConcept.TRAVEL_EXPENSE]: "Viatico",
  [BudgetConcept.BONUS]: "Bono",
  [BudgetConcept.SUBCONTRACT]: "Subcontratista",
  [BudgetConcept.VARIOUS]: "Varios",
};
